import { apiClient } from './api';
import { API_ENDPOINTS, APIHeadersWithAuth } from '../globalConstants';
import type { PaymentMethod } from '@/lib/types';

export interface PaymentMethodInput {
    name: string;
    isDefault?: boolean;
    type?: string;
}

export async function listPaymentMethods(
    shopId: number | string
): Promise<PaymentMethod[]> {
    const res = await apiClient.get<{ data: any[] }>(
        API_ENDPOINTS.paymentMethods.LIST(shopId),
        { headers: APIHeadersWithAuth() }
    );
    return res.data;
}

export async function createPaymentMethod(
    shopId: number | string,
    input: PaymentMethodInput
): Promise<PaymentMethod> {
    const res = await apiClient.post<{ data: any }>(
        API_ENDPOINTS.paymentMethods.CREATE(shopId),
        input,
        { headers: APIHeadersWithAuth() }
    );
    return res.data;
}

export async function updatePaymentMethod(
    shopId: number | string,
    id: number | string,
    input: Partial<PaymentMethodInput>
): Promise<PaymentMethod> {
    const res = await apiClient.put<{ data: any }>(
        API_ENDPOINTS.paymentMethods.UPDATE(shopId, id),
        input,
        { headers: APIHeadersWithAuth() }
    );
    return res.data;
}

export async function deletePaymentMethod(
    shopId: number | string,
    id: number | string
): Promise<void> {
    await apiClient.delete(API_ENDPOINTS.paymentMethods.DELETE(shopId, id), {
        headers: APIHeadersWithAuth(),
    });
}
